

import barba from '@barba/core';


export default class{

	constructor(){
        barba.hooks.afterOnce((data) => {
            this.header()
            this.floatingLink()
        });
        
        barba.hooks.after((data) => {
            this.header()
            this.floatingLink()
        });

    }
    header(){
        // 今回の交差を監視する要素
        const intersection = document.querySelector("[data-intersection]");
        
        if(!intersection){
            return
        }
        const header = document.querySelector('#l-header')

        const options = {
            root: null, // 今回はビューポートをルート要素とする
            rootMargin: "0px 0px", // ビューポートの中心を判定基準にする
            threshold: 0 // 閾値は0
        };
        const observer = new IntersectionObserver(doWhenIntersect, options);

        // それぞれのboxを監視する
        observer.observe(intersection);

        /**
         * 交差したときに呼び出す関数
         * @param entries
         */
        function doWhenIntersect(entries) {
            // 交差検知をしたもののなかで、isIntersectingがtrueのDOMを色を変える関数に渡す
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    header.classList.add("-is-intersect")
                }else{
                    header.classList.remove("-is-intersect")
                }
            });
        }
    }

    floatingLink(){
        // 今回の交差を監視する要素
        const intersections = document.querySelectorAll("[data-link-intersection]");
        
        if(!intersections.length > 0){
            return
        }
        const Button = document.querySelector('#c-link-button')
        const ButtonLink = Button.querySelector('a')

        const options = {
            root: null, // 今回はビューポートをルート要素とする
            rootMargin: "-80% 0px -20%", // ビューポートの中心を判定基準にする
            threshold: 0 // 閾値は0
        };
        const observer = new IntersectionObserver(doWhenIntersect, options);

        intersections.forEach(intersection => {
            // それぞれのboxを監視する
            observer.observe(intersection);
        })

        /**
         * 交差したときに呼び出す関数
         * @param entries
         */
        function doWhenIntersect(entries) {
            // 交差検知をしたもののなかで、isIntersectingがtrueのDOMを色を変える関数に渡す
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if(entry.target.getAttribute('data-href') != 'hero'){
                        ButtonLink.setAttribute( 'href', '/' + entry.target.getAttribute('data-href') + '/')
                    }else{
                        ButtonLink.setAttribute( 'href', '#concept')
                    }
                    Button.setAttribute( 'data-href', entry.target.getAttribute('data-href') )
                    if(entry.target.getAttribute('data-href') == 'hero' || entry.target.getAttribute('data-href') == 'concept' || entry.target.getAttribute('data-href') == 'business' ||  entry.target.getAttribute('data-href') == 'information'  ){
                        Button.classList.add("-show")
                    }else{
                        Button.classList.remove("-show")
                    }
                }
            });
        }
    }
}